import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["strengthIndicator", "strengthBar", "strengthText"];

  validatePassword(event) {
    const password = event.target.value;
    this.updatePasswordStrength(password);
  }

  validatePasswordConfirmation(event) {
    const password = this.element.querySelector(
      'input[name="user[password]"]',
    ).value;
    const confirmation = event.target.value;

    if (confirmation && password !== confirmation) {
      this.showPasswordMismatch();
    } else {
      this.hidePasswordMismatch();
    }
  }

  validateCurrentPassword(event) {
    // You could add AJAX validation here if needed
  }

  updatePasswordStrength(password) {
    if (!password) {
      this.hideStrengthIndicator();
      return;
    }

    this.showStrengthIndicator();

    const strength = this.calculatePasswordStrength(password);
    const percentage = strength.score * 25;
    const color = this.getStrengthColor(strength.score);
    const text = this.getStrengthText(strength.score);

    this.strengthBarTarget.style.width = `${percentage}%`;
    this.strengthBarTarget.className = `h-2 rounded-full transition-all duration-300 ${color}`;
    this.strengthTextTarget.textContent = text;
  }

  calculatePasswordStrength(password) {
    let score = 0;
    const feedback = [];

    // Length check
    if (password.length >= 8) {
      score += 1;
    } else {
      feedback.push("Au moins 8 caractères");
    }

    // Lowercase check
    if (/[a-z]/.test(password)) {
      score += 1;
    } else {
      feedback.push("Lettres minuscules");
    }

    // Uppercase check
    if (/[A-Z]/.test(password)) {
      score += 1;
    } else {
      feedback.push("Lettres majuscules");
    }

    // Number check
    if (/\d/.test(password)) {
      score += 1;
    } else {
      feedback.push("Chiffres");
    }

    // Special character check
    if (/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
      score += 1;
    } else {
      feedback.push("Caractères spéciaux");
    }

    return { score, feedback };
  }

  getStrengthColor(score) {
    if (score <= 1) return "bg-red-500";
    if (score <= 2) return "bg-orange-500";
    if (score <= 3) return "bg-yellow-500";
    if (score <= 4) return "bg-blue-500";
    return "bg-cta";
  }

  getStrengthText(score) {
    if (score <= 1) return "Très faible";
    if (score <= 2) return "Faible";
    if (score <= 3) return "Moyen";
    if (score <= 4) return "Fort";
    return "Très fort";
  }

  showPasswordMismatch() {
    const confirmationField = this.element.querySelector(
      'input[name="user[password_confirmation]"]',
    );
    confirmationField.classList.add(
      "border-red-500",
      "focus:ring-red-500",
      "focus:border-red-500",
    );
    confirmationField.classList.remove(
      "border-gray-300",
      "focus:ring-cta",
      "focus:border-cta",
    );
  }

  hidePasswordMismatch() {
    const confirmationField = this.element.querySelector(
      'input[name="user[password_confirmation]"]',
    );
    confirmationField.classList.remove(
      "border-red-500",
      "focus:ring-red-500",
      "focus:border-red-500",
    );
    confirmationField.classList.add(
      "border-gray-300",
      "focus:ring-cta",
      "focus:border-cta",
    );
  }

  showStrengthIndicator() {
    this.strengthIndicatorTarget.style.display = "block";
  }

  hideStrengthIndicator() {
    this.strengthIndicatorTarget.style.display = "none";
  }
}
